import React from "react";
import CallIcon from "@mui/icons-material/Call";
import { CancelOutlined } from "@mui/icons-material";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useTranslation } from "react-i18next";
import "webapp/styles/dialog.scss";
import { useState } from "react";
import { Fragment } from "react";
import "./Dialog.scss";
/**
 * This is a modal Function which presents a dialog box, for any quick pop up information that may be important to the user as necessary. This function is used in a bunch of various ways in this application, thus there is a bit of configuration that goes into this specific section, such that the user could be presented with
 * either a modal with a single button action, or a modal with a choice based off of `props.config`
 * @param {
 * config-boolean flag that determines which type of modal is shown
 * callback-main callbackfunction for the button title
 * title- main title for the modal
 * message- main content block for the modal
 * buttonTitle- the title of the main button
 * secondaryButtonTitle- secondary button title that is presented and accessible when the config flag is on
 * secondaryButtonAction- the accompanying callback function for the secondary button that is called when the secondary button is clicked
 * preventDismiss- when true, hide the modal close icon and block overlay/Esc dismiss (user must use footer actions)
 * hidePrimaryFooterButton- when true, hide the primary (left) footer action button — use with secondary-only flows
 * primaryMessageButtonClass- optional class applied only to the primary footer button
 * showPrimaryCancelIcon- when true, show cancel icon on the primary footer button
 * primaryButtonAction- optional callback for the primary button; when set, onClose is not called automatically
 * } props
 * @returns
 */
export default function DialogContainerTest(props) {
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();

  const styles = {
    //marginTop:"20%",
    fontFamily: "sans-serif",
    textAlign: "center",
  };

  /**
   * Callback for primary action button's onClick event
   * @param {PointerEvent} e
   */
  function onUserModalConfirm(e) {
    if (typeof props.primaryButtonAction === "function") {
      props.primaryButtonAction(e);
      return;
    }
    if (typeof props.onUserModalConfirm === "function") {
      props.onUserModalConfirm();
    }
    onClose(e);
  }

  /**
   * Callback for second action button's onClick event
   * @param {PointerEvent} e
   */
  function onUserModalConfirmAlt(e) {
    if (typeof props.secondaryButtonAction === "function") {
      props.secondaryButtonAction(e);
      // Secondary actions (e.g. cancel flow from WebAppView) typically call setState themselves.
      // Calling onClose here toggles ShowMessage false and undoes callers that reopen or replace this modal.
      return;
    }
    onClose(e);
  }

  function onClose(e) {
    //e.preventDefault();
    setIsOpen(!isOpen);

    if (typeof props.onClose === "function") {
      props.onClose();
    } else {
      console.warn("Dialog.onClose must be a function");
    }
  }

  return (
    <div style={styles}>
      {props.config === true && (
        <Modal
          open={isOpen}
          onClose={onClose}
          showCloseIcon={!props.preventDismiss}
          closeOnOverlayClick={!props.preventDismiss}
          closeOnEsc={!props.preventDismiss}
        >
          <h2 style={{ marginTop: 30 }}>{t("description." + props.title)}</h2>
          <div>{props.message}</div>
          <div className="footerContainer">
            {!props.hidePrimaryFooterButton && (
              <div
                type="hidden"
                id="tapForRoadside"
                onClick={onUserModalConfirm}
                className={`footer ${props.MessageButtonClass || ""}`}
              >
                <span>{props.buttonTitle}</span>
              </div>
            )}
          </div>
        </Modal>
      )}
      {!props.config && (
        <Modal
          open={isOpen}
          onClose={onClose}
          showCloseIcon={!props.preventDismiss}
          closeOnOverlayClick={!props.preventDismiss}
          closeOnEsc={!props.preventDismiss}
        >
          <h2 style={{ marginTop: 30 }}>{t("description." + props.title)}</h2>
          <Fragment>{t("description." + props.message)}</Fragment>
          {props.secondaryButtonTitle && !props.hidePrimaryFooterButton && !props.isProviderEnroute ? (
            <div className="footerContainer dialog-dual-footer" style={{ display: "flex" }}>
              <div>
                <div
                  type="hidden"
                  id="tapForRoadside"
                  onClick={onUserModalConfirm}
                  className={`footer ${props.MessageButtonClass || ""} ${props.primaryMessageButtonClass || "footer-cancel-light"}`}
                >
                  {props.showPrimaryCancelIcon && (
                    <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                  )}
                  <span style={{ marginLeft: "0px" }}>{t("description." + props.buttonTitle)}</span>
                </div>
              </div>
              <div>
                <div type="hidden" id="tapForRoadside" onClick={onUserModalConfirmAlt} className="ui-btn">
                  {t("description." + props.secondaryButtonTitle)}
                </div>
              </div>
            </div>
          ) : (
            <div className="footerContainer">
              {!props.isProviderEnroute && !props.hidePrimaryFooterButton ? (
                <div
                  type="hidden"
                  id="tapForRoadside"
                  onClick={onUserModalConfirm}
                  className={`footer ${props.MessageButtonClass || ""} ${props.primaryMessageButtonClass || ""}`}
                >
                  {props.showPrimaryCancelIcon && (
                    <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                  )}
                  <span>{t("description." + props.buttonTitle)}</span>
                </div>
              ) : (
                <></>
              )}

              {props.isProviderEnroute ? (
                <div
                  type="hidden"
                  id="tapForRoadside"
                  onClick={props.callCallBackNumber}
                  style={{
                    maxWidth: "none !important",
                  }}
                  className={`footer ${props.MessageButtonClass || ""}`}
                >
                  <CallIcon style={{ marginRight: "5px" }} />
                  {t("description.CallRoadsideAssistance")}
                </div>
              ) : (
                <></>
              )}

              {!props.isProviderEnroute && props.secondaryButtonTitle && (
                <div
                  type="hidden"
                  id="tapForRoadside"
                  onClick={onUserModalConfirmAlt}
                  className={`footer ${props.MessageButtonClass || ""} footer-close-secondary`}
                >
                  <span>{t("description." + props.secondaryButtonTitle)}</span>
                </div>
              )}
            </div>
          )}
        </Modal>
      )}
    </div>
  );
}
